export function ShoppingAddToBag({
  color = '#FFFFFF',
  height = 21,
  width = 21,
}: {
  color?: string
  width?: number
  height?: number
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.92798 4.76608C9.34812 5.59897 8.94996 6.8639 8.94996 8.50005H7.44996C7.44996 6.6362 7.90181 5.05112 8.69694 3.90902C9.49812 2.75824 10.6615 2.05005 12 2.05005C13.3503 2.05005 14.5113 2.79495 15.3055 3.95015C16.0964 5.1005 16.55 6.68228 16.55 8.50005H15.05C15.05 6.91782 14.6536 5.64959 14.0694 4.79995C13.4886 3.95515 12.7496 3.55005 12 3.55005C11.2384 3.55005 10.5018 3.94186 9.92798 4.76608ZM1.97021 10.05H21.9277L20.8333 15.1572L19.3666 14.8429L20.0722 11.55H3.82971L5.73549 20.3529C5.75221 20.4365 5.78579 20.4762 5.81333 20.4978C5.84356 20.5216 5.90121 20.55 5.99996 20.55H15V22.05H5.99996C5.17166 22.05 4.44345 21.5263 4.26584 20.6537L1.97021 10.05ZM17.05 17.05V14.8H18.55V17.05H20.8V18.55H18.55V20.8H17.05V18.55H14.8V17.05H17.05Z"
        fill={color}
      />
    </svg>
  )
}
